import 'slick-carousel';

jQuery(document).ready(function ($) {
    const base = 'growl-component-hero';

    $(`.${base}__slider-inside`).slick({
        arrows: false
    });

    $(`.${base}__previous`).click(function(e) {
        e.preventDefault();

        $(`.${base}__slider-inside`).slick('slickPrev');
    });

    $(`.${base}__next`).click(function(e) {
        e.preventDefault();

        $(`.${base}__slider-inside`).slick('slickNext');
    });

});